import type { SVGProps } from 'react';

const SvgMoneyTransaction = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15 14c0-2.08-1.95-2.71-2.69-2.95C11 10.62 11 10.29 11 10c0-.55.45-1 1-1 .26 0 .51.1.7.29a.996.996 0 1 0 1.4-1.42c-.32-.31-.69-.53-1.1-.68v-.18c0-.55-.45-1-1-1s-1 .45-1 1v.18c-1.16.41-2 1.51-2 2.82 0 2.06 1.88 2.68 2.69 2.95 1.31.42 1.31.78 1.31 1.05a1.003 1.003 0 0 1-1.87.5 1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37.36.62.94 1.07 1.6 1.3v.2c0 .55.45 1 1 1s1-.45 1-1v-.18c1.16-.41 2-1.51 2-2.82zm1-7h.59l-.29.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2-2a.996.996 0 0 0 0-1.41l-2-2a.996.996 0 1 0-1.41 1.41l.29.29h-.59c-.55 0-1 .45-1 1s.45 1 1 1zM5 10c.55 0 1-.45 1-1 0-1.1.9-2 2-2 .55 0 1-.45 1-1s-.45-1-1-1C5.79 5 4 6.79 4 9c0 .55.45 1 1 1m3 7h-.59l.29-.29a.996.996 0 1 0-1.41-1.41l-2 2a.996.996 0 0 0 0 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.29-.29h.59c.55 0 1-.45 1-1s-.45-1-1-1zm11-3c-.55 0-1 .45-1 1 0 1.1-.9 2-2 2-.55 0-1 .45-1 1s.45 1 1 1c2.21 0 4-1.79 4-4 0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgMoneyTransaction;
